export default __webpack_public_path__ + "static/media/093-diagonal-arrow-14.e915a87b.png";